// NBA team name to CDN numeric ID mapping
// Source: https://github.com/bttmly/nba/blob/master/data/teams.json (verified 2026-03-20)
// IDs confirmed against https://cdn.nba.com/logos/nba/{id}/primary/L/logo.svg
//
// Includes all 30 canonical full names + common DraftKings short-name aliases
// (DK scraper may store short names like "Thunder", "Lakers", "OKC Thunder", etc.)

export const NBA_TEAM_IDS: Record<string, number> = {
  // --- All 30 full team names ---
  'Atlanta Hawks':           1610612737,
  'Boston Celtics':          1610612738,
  'Brooklyn Nets':           1610612751,
  'Charlotte Hornets':       1610612766,
  'Chicago Bulls':           1610612741,
  'Cleveland Cavaliers':     1610612739,
  'Dallas Mavericks':        1610612742,
  'Denver Nuggets':          1610612743,
  'Detroit Pistons':         1610612765,
  'Golden State Warriors':   1610612744,
  'Houston Rockets':         1610612745,
  'Indiana Pacers':          1610612754,
  'Los Angeles Clippers':    1610612746,
  'Los Angeles Lakers':      1610612747,
  'Memphis Grizzlies':       1610612763,
  'Miami Heat':              1610612748,
  'Milwaukee Bucks':         1610612749,
  'Minnesota Timberwolves':  1610612750,
  'New Orleans Pelicans':    1610612740,
  'New York Knicks':         1610612752,
  'Oklahoma City Thunder':   1610612760,
  'Orlando Magic':           1610612753,
  'Philadelphia 76ers':      1610612755,
  'Phoenix Suns':            1610612756,
  'Portland Trail Blazers':  1610612757,
  'Sacramento Kings':        1610612758,
  'San Antonio Spurs':       1610612759,
  'Toronto Raptors':         1610612761,
  'Utah Jazz':               1610612762,
  'Washington Wizards':      1610612764,

  // --- DraftKings short-name aliases (playoff-likely teams) ---
  'Thunder':             1610612760,
  'OKC Thunder':         1610612760,
  'OKC':                 1610612760,
  'Celtics':             1610612738,
  'Boston':              1610612738,
  'Lakers':              1610612747,
  'LA Lakers':           1610612747,
  'Cavaliers':           1610612739,
  'Cavs':                1610612739,
  'Cleveland':           1610612739,
  'Nuggets':             1610612743,
  'Denver':              1610612743,
  'Knicks':              1610612752,
  'New York':            1610612752,
  'NY Knicks':           1610612752,
  'Pacers':              1610612754,
  'Indiana':             1610612754,
  'Bucks':               1610612749,
  'Milwaukee':           1610612749,
  'Heat':                1610612748,
  'Miami':               1610612748,
  'Warriors':            1610612744,
  'Golden State':        1610612744,
  'GSW':                 1610612744,
  'Clippers':            1610612746,
  'LA Clippers':         1610612746,
  'Timberwolves':        1610612750,
  'Minnesota':           1610612750,
  'T-Wolves':            1610612750,
  'Suns':                1610612756,
  'Phoenix':             1610612756,
  'Kings':               1610612758,
  'Sacramento':          1610612758,
  'Mavericks':           1610612742,
  'Mavs':                1610612742,
  'Dallas':              1610612742,
  'Rockets':             1610612745,
  'Houston':             1610612745,
  'Grizzlies':           1610612763,
  'Memphis':             1610612763,
  'Hawks':               1610612737,
  'Atlanta':             1610612737,
  '76ers':               1610612755,
  'Sixers':              1610612755,
  'Philadelphia':        1610612755,
  'Magic':               1610612753,
  'Orlando':             1610612753,
  'Raptors':             1610612761,
  'Toronto':             1610612761,
  'Spurs':               1610612759,
  'San Antonio':         1610612759,
  'Pistons':             1610612765,
  'Detroit':             1610612765,
  'Nets':                1610612751,
  'Brooklyn':            1610612751,
  'Bulls':               1610612741,
  'Chicago':             1610612741,
  'Jazz':                1610612762,
  'Utah':                1610612762,
  'Trail Blazers':       1610612757,
  'Blazers':             1610612757,
  'Portland':            1610612757,
  'Pelicans':            1610612740,
  'New Orleans':         1610612740,
  'Wizards':             1610612764,
  'Washington':          1610612764,
  'Hornets':             1610612766,
  'Charlotte':           1610612766,
};

export function getTeamAbbr(name: string): string {
  if (!name) return '??';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].substring(0, 3).toUpperCase();
  return parts.map(p => p[0]).join('').toUpperCase().substring(0, 3);
}
